import { render, staticRenderFns } from "./dictItemDrawer.vue?vue&type=template&id=7ef55a8c&scoped=true&"
import script from "./dictItemDrawer.vue?vue&type=script&lang=js&"
export * from "./dictItemDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef55a8c",
  null
  
)

export default component.exports